export const USERS_ON_DELETE_REQUESTED = 'USERS_ON_DELETE_REQUESTED';
export const USERS_ON_DELETE_SUCCEEDED = 'USERS_ON_DELETE_SUCCEEDED';
export const USERS_ON_DELETE_FAILED = 'USERS_ON_DELETE_FAILED';

export const USERS_ON_GET_ALL_REQUESTED = 'USERS_ON_GET_ALL_REQUESTED';
export const USERS_ON_GET_ALL_SUCCEEDED = 'USERS_ON_GET_ALL_SUCCEEDED';
export const USERS_ON_GET_ALL_FAILED = 'USERS_ON_GET_ALL_FAILED';

export const USERS_ON_GET_ONE_REQUESTED = 'USERS_ON_GET_ONE_REQUESTED';
export const USERS_ON_GET_ONE_SUCCEEDED = 'USERS_ON_GET_ONE_SUCCEEDED';
export const USERS_ON_GET_ONE_FAILED = 'USERS_ON_GET_ONE_FAILED';

export const USERS_ON_SAVE_REQUESTED = 'USERS_ON_SAVE_REQUESTED';
export const USERS_ON_SAVE_SUCCEEDED = 'USERS_ON_SAVE_SUCCEEDED';
export const USERS_ON_SAVE_FAILED = 'USERS_ON_SAVE_FAILED';
